import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { ManagerOverviewInfoProps } from "./ManagerOverviewInfo.types";

export const ManagerOverviewInfo: React.FC<ManagerOverviewInfoProps> = ({
  title,
  text,
  subText,
  ...rest
}) => {
  return (
    <Box {...rest}>
      <Text
        textStyle="bodySmall"
        lineHeight="22px"
        color="text.grey"
        fontWeight="600"
        textTransform="uppercase"
        fontFamily="heading"
      >
        {title}
      </Text>
      <Flex alignItems="center">
        <Text lineHeight="22px" color="text.black" textStyle="h6">
          {text}
        </Text>
      </Flex>
      {subText && (
        <Text
          lineHeight="20px"
          fontWeight={"normal"}
          fontSize={"12px"}
          color="text.grey"
        >
          {subText}
        </Text>
      )}
    </Box>
  );
};
